module.exports = __webpack_public_path__ + "static/media/april.05ef893b.jpg";